import type { FaireProductEntity } from "../../entity_types/product";

export const p_pwaxgj5caz: FaireProductEntity = {
  token: "p_pwaxgj5caz",
  type: "product",
  name: "Plumeria & Palaka - Gift Tags (Set of 5)",
  brandName: "Design Jord",
  imageUrl:
    "https://cdn.faire.com/fastly/b7c8bccf3b4da8fc9a9b813d42ecf79afee03be4643b67e3c300a8c46e7f4680.jpeg",
  priceDollars: 3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/978570c0dfdaf8951f91dae6e05292197d7f5beb166343971e9e53fe38749918.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
